<template>
  <div class="banner" :class="cssType">
    <div class="logo" :class="locale"></div>
    <!-- <div class="main-title" :class="locale"></div> -->
    <img :src="cssType === 'mobile' ? mainTitleMobileImg : mainTitleImg" alt="mainTitle" class="main-title" :class="locale">
    <CountDown
      class="count-down"
      :realTime="props.realTime"
      :activeStartTime="props.activeStartTime"
      :activeEndTime="props.activeEndTime"
      :pageCloseTime="props.pageCloseTime"
      @end="emit('end')"
    />
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'
import { isMobile } from '@/utils'
import { useI18n } from 'vue-i18n'
import CountDown from './CountDown/index.vue'
import mainTitleImg from '../../assets/imgs/mainTitle/index.js'
import mainTitleMobileImg from '../../assets/imgs/mobile/mainTitle/index.js'

const { locale } = useI18n()
const cssType = isMobile ? 'mobile' : 'pc'
const emit = defineEmits(['end'])

const props = defineProps({
  realTime: {
    type: Number,
    default: 0,
  },
  activeStartTime: {
    type: [Number, String],
    default: 0,
  },
  activeEndTime: {
    type: [Number, String],
    default: 0,
  },
  pageCloseTime: {
    type: [Number, String],
    default: 0,
  },
})
</script>

<style src="./pc_style.less" lang="less" scoped></style>
<style src="./mobile_style.less" lang="less" scoped></style>
